export function Avatar({ initials, name, size = 'md' }: { initials: string; name: string; size?: 'sm' | 'md' }) {
  return <span className={`avatar avatar--${size}`} title={name} aria-label={name}>{initials}</span>;
}
